import React from 'react';
import css from './style.scss'
import api from '../api'
import store from 'utils/store'
import Button from 'components/shared/button';
import analytics from 'utils/analytics'


class CouponElement extends React.Component{
  constructor(props){
    super(props)
    this.state={
      coupon:undefined,
      show:false
    }
  }
  toggle=()=>{
    this.setState({show:true})
  }
  checkIfValid = (e) => {
    e.preventDefault()
    e.stopPropagation()
    let value=this.refs.coupon.value
    if(value==="test-day"){
      //use coupon to set test-day plan
      this.props.onCoupon(value)
      this.setState({
        coupon:{
          percent_off:"test",
          duration:"test-day"
        }
      })
    }else{
      api.checkCoupon(value).then(resp=>{
        analytics.track("use_coupon")
        this.props.onCoupon(value)
        this.setState({coupon:resp})
      }).catch(err=>{
        this.props.onCoupon(undefined)
        store.dispatch({type:"ADD_TOAST", message:"This coupon is not valid."})
        this.setState({coupon:undefined})
      })
    }

  }
  addCoupon=(coupon)=>{
    this.setState({coupon})
  }
  render() {
    if(this.state.show){
      return (
        <div className={css.couponElement}>
          {!this.state.coupon &&
            <div className={css.form}>
              <input name="coupon" type="text" ref="coupon" placeholder="Add your coupon..."/><Button onClick={this.checkIfValid} small>Check</Button>
            </div>
          }
          {this.state.coupon &&
            <p className={css.coupon}>You are applying a {this.state.coupon.percent_off}% deduction {this.state.coupon.duration ? "for "+this.state.coupon.duration+" months" : "forever"}. Awesome!</p>
          }
        </div>
      )
    }else{
      return (
        <div className={css.couponTrigger} onClick={this.toggle}>
          Do you have a coupon?
        </div>
      )
    }
  }
}

export default CouponElement;



// WEBPACK FOOTER //
// ./src/components/subscriptions/modal/checkout_form/coupon_element.js